import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-td-gaz',
  templateUrl: './td-gaz.component.html',
  styleUrls: ['./td-gaz.component.scss']
})
export class TdGazComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
